module.exports = __webpack_public_path__ + "static/img/TGHover.7155732.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/funImg/TGHover.png
// module id = 0aej
// module chunks = 1